"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUtag = exports.getUtagData = exports.getUtagQueue = void 0;
var tealiumWindow = window;
function getUtagQueue() {
    return tealiumWindow.utagQueue;
}
exports.getUtagQueue = getUtagQueue;
function getUtagData() {
    return tealiumWindow.utag_data;
}
exports.getUtagData = getUtagData;
function getUtag() {
    return tealiumWindow.utag;
}
exports.getUtag = getUtag;
